import { Divider, Typography } from '@mui/material';
import { get } from 'lodash';
import React from 'react';
import SummaryLine from 'src/components/ui-component/form-component/abschluss-page/SummaryLine';
import MarkdownRenderer from 'src/components/ui-component/markdown-renderer/MarkdownRenderer';
import { useApplication } from 'src/context/ApplicationContext';
import { PLATZHALTER_TEXT } from 'src/lib/constants/constant';
import AbschlussSeiteBox from 'src/pages/private/online-antrag/antrag-components/AbschlussSeiteBox';
import ApplicationHeading from 'src/pages/private/online-antrag/application-heading/ApplicationHeading';
import { DisplayDateTime, DisplayDecimal, DisplayEuro } from 'src/utils/formats';

// import schemas
import VerwendungsnachweisSchemaSchema from 'src/lib/paths/verwendungsnachweis_FULL_Paths.json';
const VN_P = VerwendungsnachweisSchemaSchema.attributes;

export default function VNAngabenPruefen({ untertitel, inhalt }: { untertitel: string; inhalt: string }) {
	const { application } = useApplication();

	return (
		<>
			<ApplicationHeading title={untertitel} description={PLATZHALTER_TEXT} />
			<MarkdownRenderer markdown={inhalt} />

			<AbschlussSeiteBox>
				<SummaryLine
					label='Datum der Einreichung'
					value={
						get(application, VN_P.Allgemein_Eingereicht_Am.path) ?
							DisplayDateTime(get(application, VN_P.Allgemein_Eingereicht_Am.path))
						:	'noch nicht eingereicht'
					}
				/>
				<SummaryLine label='Projekttitel' value={get(application, VN_P.Foerderantrag.schema.attributes.Allgemein_Projekttitel.path, '')} />
				<SummaryLine
					label='Bewilligte Förderung (gemäß Bescheid)'
					value={DisplayEuro(get(application, VN_P.Foerderantrag.schema.attributes.Bewilligung_Bewilligte_Zuwendung.path, ''))}
				/>
				<SummaryLine
					label='Förderquote (gemäß Bescheid)'
					value={DisplayDecimal(get(application, VN_P.Foerderantrag.schema.attributes.Bewilligung_Foerderquote_Gesamt.path, ''), true)}
				/>

				<Divider sx={{ color: '#000', my: '2rem', borderBottom: '1px dotted' }} />

				<SummaryLine
					label='Gesamtsumme der Ausgaben im betrachteten Haushaltsjahr'
					value={DisplayEuro(get(application, VN_P.Summe_Ausgaben_im_Betrachteten_Haushaltsjahr.path, 0))}
					alignValueRight={true}
				/>
				<SummaryLine
					label='Gesamtsumme der Zuwendung anteilig im betrachteten Haushaltsjahr'
					value={DisplayEuro(get(application, VN_P.Summe_Zuwendung_im_Betrachteten_Haushaltsjahr.path, 0))}
					alignValueRight={true}
				/>

				<Divider sx={{ color: '#000', my: '2rem', borderBottom: '1px dotted' }} />

				<SummaryLine
					label='Aktuell getätigte Investitionskosten (gemäß Nachweis)'
					value={DisplayEuro(get(application, VN_P.Ermittlung_Des_Auszahlungsbetrages_Zuwendungsfaehige_Ausgaben.path, 0))}
					alignValueRight={true}
				/>
				<SummaryLine
					label='Zuwendung anteilig (gemäß Förderquote)'
					value={DisplayEuro(get(application, VN_P.Ermittlung_Des_Auszahlungsbetrages_Zuwendung_Anteilig.path, 0))}
					alignValueRight={true}
				/>
				<SummaryLine
					label='Bereits abgerufene Zuwendung im gleichen Projektjahr'
					value={DisplayEuro(get(application, VN_P.Ermittlung_Des_Auszahlun_0254424978_ngen_Im_Gleichen_Projektjahr.path, '0'))}
					alignValueRight={true}
				/>
				{/* <SummaryLine
					label='Nach aktuellem Abruf verfügbare Zuwendung (gemäß Bescheid)'
					value={DisplayEuro(verfuegbareZuwendung)}
					alignValueRight={true}
				/> */}
				<SummaryLine
					label='Aktuell beantragter Mittelabruf *'
					value={DisplayEuro(get(application, VN_P.Ermittlung_Des_Auszahlungsbetrages_Zuwendung_Anteilig.path, 0))}
					alignValueRight={true}
					boldLabel={true}
					showBackground={true}
				/>
			</AbschlussSeiteBox>

			{/* <Box sx={{ mt: '2rem' }}> */}
			<Typography variant='body2' sx={{ mt: 2, display: 'block' }}>
				* Dieser Mittelabruf wurde automatisch durch das digitale Antragsportal der Innovationsförderung Hessen – basierend auf den von Ihnen
				gemachten Angaben – generiert und steht unter dem Vorbehalt einer fachlichen Prüfung durch die Hessen Agentur.
			</Typography>
			{/* </Box> */}
		</>
	);
}
